import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BabyBookin from './BabyBookin.jsx';
import PrivacyPolicy from './PrivacyPolicy.jsx';
import TermsOfService from './TermsOfService.jsx';
import FAQ from './FAQ.jsx';

function App() {
  // DISABLED: SyncService - using Share Extension instead
  
  return (
    <Routes>
      <Route path="/" element={<BabyBookin />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/faq" element={<FAQ />} />
    </Routes>
  );
}

export default App;
